import {Box} from '@mantine/core';
import Image from 'next/image';
import {GoogleAdBannerName} from '../../../config/constants/googleAdBanner';
import {BANNER_EVENT_IMAGE} from '../../../config/constants/img';
import {GoogleAdBanner} from '../../../shared/components/Banner/GoogleAdBanner';
import {CommonLink} from '../../../shared/components/CommonLink';
import {GeneralFooter} from '../../../shared/components/Footer/general';
import {GeneralHeaderContainer} from '../../../shared/components/Header/General/container';
import {useIsAppWebView} from '../../../shared/hooks/useIsAppWebView';
import {useGoogleAdBanner} from '../../../shared/services/useGoogleAdBanner';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

export const RemindPassLayout = ({children}: React.PropsWithChildren) => {
  const isWebView = useIsAppWebView();
  const {isPC} = useMediaQuery();
  const googleAdBannerNames = [
    GoogleAdBannerName.B_RECTANGLE,
    GoogleAdBannerName.B_RECTANGLE_BOTTOM,
  ];
  useGoogleAdBanner(googleAdBannerNames);

  return (
    <>
      <div>
        {!isWebView && <GeneralHeaderContainer />}
        <main>
          <Box className="min-h-screen py-12 pc:bg-background-1 pc:py-32">
            <Box className="mx-auto my-0 max-w-[1200px] overflow-hidden">
              <Box className="flex items-start gap-x-16">
                {isPC && <Box className="w-[200px]" />}
                <Box className="w-full max-w-[664px] bg-background-1">
                  {children}
                </Box>
                {isPC && (
                  <Box className="w-[320px]">
                    <Box className="sticky top-[150px] flex flex-col gap-y-8">
                      <GoogleAdBanner
                        googleAdBannerName={GoogleAdBannerName.B_RECTANGLE}
                      />
                      <CommonLink
                        href="https://event.gaishishukatsu.com/"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <Image
                          src={BANNER_EVENT_IMAGE}
                          alt="開催イベント一覧"
                          width={300}
                          height={80}
                        />
                      </CommonLink>
                      <GoogleAdBanner
                        googleAdBannerName={
                          GoogleAdBannerName.B_RECTANGLE_BOTTOM
                        }
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </main>
        {!isWebView && <GeneralFooter />}
      </div>
    </>
  );
};
